import "Config/faIcons";
import { initAnalytics } from "./utils/analytics";
import "Config/mobx";
import "Config/polyfills";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "styles/app.less";
import { register } from "./serviceWorkerRegistration";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <Suspense fallback="loading">
      <App />
    </Suspense>
  );
}

register();
initAnalytics();
